var amdi18n={"__root":{"title":"Invitation Accepted!","disclaimer":"Your username and email address will be visible to the account administrators and owner. The account owner and admins can also modify or terminate your access to their account at any time.","logged_in":"To collaborate, use the account dropdown to navigate between your personal and collaborator accounts.","not_logged_in":"To collaborate, sign in and use the account dropdown to navigate between your personal and collaborator accounts.","new_user_title":"Create an account to collaborate","new_user_subtitle":"To collaborate follow these two simple steps:","new_user_list_item_1":"Create an account and sign in","new_user_list_item_2":"Use the Account dropdown to switch between personal and collaborator accounts","new_user_disclaimer":"Your username and email address will be visible to Administrators on the collaborator's account.","new_user_button":"Got it","button_close":"Close"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;